import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import ReservedActions, { ReservedRedux, ReservedTypes } from '../Redux/ReservedRedux'
import ReservedEnrollmentsActions from '../Redux/ReservedEnrollmentsRedux'
import ClassroomActions from '../Redux/ClassroomRedux'
import { notificationSuccess } from '../Redux/NotificationActions'

const reservedCrudObservable = createCRUDObservable({
  mainRedux: ReservedRedux,
  reduxPath: 'reserved',
})

const postReservedEpic = (action$, store, { Api }) =>
  action$.ofType(ReservedTypes.reservedRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.reserved.postReserved(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [ReservedActions.reservedFailure(result.error)]
          }
          const { data: { data: payload } } = result
          return [
            ReservedActions.reservedSuccess(payload),
            notificationSuccess('Alumno Registrado'),
            ReservedEnrollmentsActions.updateDataAfterInscription(payload),
            ClassroomActions.updateDataAfterInscription(payload),
          ]
        })
    ))


export const reservedObservers = Object.assign({}, reservedCrudObservable.observers, {
  postReservedEpic,
})

export const reservedEpic = combineEpics(
  postReservedEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReservedObservable.js